import { connectRouter, LocationChangeAction, RouterState } from "connected-react-router";
import { History } from "history";
import { Reducer } from "react";
import { combineReducers } from "redux";

import * as settingsStore from "./Slice/SettingsSlice";
import * as contentTypesStore from "./Slice/ContentTypesSlice";
import * as pageHeaderStore from "./Slice/PageHeaderSlice";
import * as taxonomiesStore from "./Slice/TaxonomiesSlice";
import * as categoriesStore from "./Slice/CategoriesSlice";
import * as contentTypeConfigsStore from "./Slice/ContentTypeConfigsSlice";

// required for the autocomplete
export { settingsStore, contentTypesStore, pageHeaderStore, taxonomiesStore, categoriesStore, contentTypeConfigsStore };

export interface IApplicationState {
    router: Reducer<RouterState, LocationChangeAction>;
    settings: settingsStore.ISettingsState;
    contentTypes: contentTypesStore.ContentTypesState;
    pageHeader: pageHeaderStore.PageHeaderState;
    taxonomies: taxonomiesStore.TaxonomiesState;
    categories: categoriesStore.CategoriesState;
    contentTypeConfigs: contentTypeConfigsStore.ContentTypeConfigsState;
}

const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        settings: settingsStore.reducer,
        contentTypes: contentTypesStore.reducer,
        pageHeader: pageHeaderStore.reducer,
        taxonomies: taxonomiesStore.reducer,
        categories: categoriesStore.reducer,
        contentTypeConfigs: contentTypeConfigsStore.reducer,
    });

export default createRootReducer;
